import type { HelpFile } from '../../types/help'
import { TypeScopeFilterTestIds } from '../../../testids/TypeScopeFilterTestIds'

export const typeScopeFilterHelp: HelpFile = {
  docPage: '/docs/admin/attributes',
  texts: {
    [TypeScopeFilterTestIds.typeScopeAll]:
      'Show definitions across every type and the global scope combined.',
    [TypeScopeFilterTestIds.typeScopeGlobal]:
      'Show only definitions whose scope is global — not bound to any specific type.',
  },
}
